import {get as _get} from "lodash";
import PropTypes from "prop-types";

export const exportExcel = (dataExport) => ({
    dataExport: dataExport,
    filename: 'venues',
    parseData: venue => [
        venue.id,
        venue.name,
        _get(venue, 'city.name', ''),
        venue.capacity || '',
    ],
    path: 'venues.index.path',
    titles: [
        "ID",
        "Name",
        "City",
        "Capacity",
    ],
});

exportExcel.propTypes = {
    dataExport: PropTypes.array.isRequired
};
